<template>
  <td>
    <div class="flexColumn">
      <div v-if="showTagName">
        {{ tag.name.value }}
      </div>

      <button v-if="controls.length == 0" class="channelPickerButton" @click="openDialog(null)"></button>
      <template v-for="control in controls">
        <button class="channelPickerButton" :class="channelPickerButtonClass(control)" @click="openDialog(control)">
          {{ controlChannelLabel(control) }}
        </button>
      </template>

      <template v-if="showingDialog">
        <ChannelAssignmentsSettingDialog v-model:showingDialog="showingDialog"
          :title="row.rowName"
          :controllers="controllers"
          :channelMap="channelMap"
          :container="tag"
          :controlsTag="controlsTag"
          :isAuxiliary="isAuxiliaryAggregate"
          :selectedControl.sync="selectedControl"
          @close="closeDialog()"
        ></ChannelAssignmentsSettingDialog>
      </template>

    </div>
  </td>
</template>

<script>
import { uniqueBy } from "./utility.js";
import { controlChannelLabel, isAssigned } from "./appUtility.js";
import ChannelAssignmentsSettingDialog from "./ChannelAssignmentsSettingDialog.vue";

export default {
  components: { ChannelAssignmentsSettingDialog },
  props: [
    "row",
    "tag",
    "controllers",
    "channelMap"
  ],
  data() {
    return {
      showingDialog: false,
      selectedControl: null
    }
  },
  methods: {
    openDialog(control) {
      this.showingDialog = true;
      this.selectedControl = control;
    },
    closeDialog() {
      this.showingDialog = false;
      this.selectedControl = null;
    },
    channelPickerButtonClass(control) {
      if (!this.tag.sensors) return {};
      
      let boardId = control.boardId.value;
      if (!boardId) return {};
      
      let controller = this.controllers.find(controller => controller.boardId == boardId);
      if (!controller.online) return {};
      
      let portNumber = control.portNumber.value;
      let port = controller.ports[portNumber];
      let channelNumber = control.channelNumber.value;
      let channel = port.analogInputs.children[channelNumber];
      let sensorModelNumber = channel.sensorModelNumber.value;
      let sensorModel = controller.sensorModels[sensorModelNumber];
      
      let sensorConflictWarning = false;
      if (controller.autoConfigureEnabled) {
        let controlsOnThisChannel = this.channelMap[channelNumber].filter(_control =>
          _control.controlType == "ani" &&
          _control.boardId == controller.boardId &&
          _control.portNumber == portNumber &&
          _control.channelNumber == channelNumber
        );
        let uniqueSensorTypes = uniqueBy(controlsOnThisChannel, control => control.sensorType);
        sensorConflictWarning = uniqueSensorTypes.length > 1;
      }
      else {
        let aggr = control.$parent.$parent;
        sensorConflictWarning = aggr.sensorType.value != sensorModel.sensorType.value;
      }
      return { sensorConflictWarning };
    },
    controlChannelLabel(control) {
      return controlChannelLabel(control);
    }
  },
  computed: {
    controlsTag() {
      let tag = this.tag;
      if (tag.sensors) 
        return tag.sensors;
      if (tag.digitalOutputs)
        return tag.digitalOutputs;
      if (tag.children)
        return tag;
      else
        return null;
    },
    controls() {
      if (this.controlsTag) 
        return this.controlsTag.children.filter((control, index) => 
          (index == 0) || isAssigned(control)
        );
      else
        return [ this.tag ];
    },
    isAuxiliaryAggregate() {
      return this.tag.$path().includes("auxiliaries");
    },
    showTagName() {
      let parent = this.tag.$parent;

      return (
        parent.defaultName_multiple && 
        this.controls.some(isAssigned) &&
        this.tag.name.value != parent.defaultName_multiple.replace("{#}", this.tag.$key() + 1)
      );
    }
  }
}
</script>

<style scoped>
.flexColumn {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 5px;
  padding: 5px;
}
button {
  min-width: 100px;
  min-height: 33px;
  border-radius: 5px;
  border: 1px solid #777;
  cursor: pointer;
}
button.sensorConflictWarning { 
  background: #ff000040; 
}
</style>
